<div
    class="content"
    [formGroup]="form"
>
    <app-campaign-parameters-name [control]="form.controls.name" />
    <app-campaign-parameters-budget
        [formGroup]="form"
        [minBudgetValue]="minBudget"
    />
    <app-campaign-parameters-audience-segments
        [formGroup]="form.controls.audienceSegments"
        *ngIf="form.controls.audienceSegments"
        [audienceSegments]="audienceSegments"
    />
    <rm-retail-media-parameters-agreement
        *ngIf="form.controls.agreement"
        [control]="form.controls.agreement"
    />
    <app-campaign-terms
        *ngIf="form.controls.customerServiceAgreement"
        [form]="form.controls.customerServiceAgreement"
        header="Weryfikacja warunków kampanii"
    >
        Zweryfikowałem i sprawdziłem warunki przed wysłaniem do klienta
    </app-campaign-terms>
</div>
